var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hooper',{ref:"hooper",style:({ height: 'auto' }),attrs:{"settings":_vm.hooperSettings},on:{"afterSlide":_vm.updateWidth}},[_vm._l((_vm.imgArray),function(img,index){return _c('slide',{key:index},[_c('div',{staticClass:"slider_home_bottom",style:({
        'background-image': `url(${_vm.$imgUrl(`area/${img}`)})`,
      })})])}),_c('hooper-pagination',{attrs:{"slot":"hooper-addons"},slot:"hooper-addons"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }